import { ENV } from "../../../../src/app/interfaces/interfaces";

export const environment:ENV = {
    production: false,
    apiUrl: 'https://todotix.gateway.test.todotix.net/', //Test
    ticketsUrl: 'https://tickets.admin.todotix.test.front.solunes.com/', //ir a admin de tickets http://localhost:52280/
    vaucherUrl: 'https://todotix.vouchers.test.todotix.net/',
    mapsUrl: 'https://nacionalseguros.gateway.test.solunes.com/', //para el módulo de mapas
    imagesServe: "https://todotix.assets.test.todotix.net/",
    type: 'todotix',
    title: 'todotix',
    subtitle: 'Membresías',
    description: `"todotix" es un sitio en el que puedes administrar tus membresías, como las de socios, entradas y abonos.`,
    keywords: 'todotix, campeon, todotix, membresias, socios, abonos, entradas, tickets',
    yearProyect: '2024',
    imgLogoIcon: '/assets/img/isotipo.svg',
    imgLogoIconWhite: '/assets/img/isotipo-white.svg',
    imgLogo: '/assets/img/logo.png',
    imgLogoSVG: '/assets/img/isologo.svg',
    imgLogoWhiteSVG: '/assets/img/isologo-white.svg',
    imgLogoWhite: '/assets/img/logo-white.png',

    templateType: 'template-1',
    theme: 'light',
    changeTheme: false,

    byDevelopment:'Desarrollado por Solunes Digital',

    authGoogle: false,
    authFacebook: false,
    authApple: false,
    authGithub: false,

    forgetPassword: true,

    authRedirect: '',

    loaderType: 1,
    loaderDefaultText: 'Cargando...',

    //* Firebase
    firebase: null,

    keyEncript: '12345678901234567890123456789012',
    ivEncript: '1234567890123456',
};
